import { useTranslation } from 'react-i18next'

const CashierStart = (props) => {
  const { t } = useTranslation()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="cashier-start-title"
      {...props}
    >
      <title id="cashier-start-title">{t('antagonists:cashier:components:start')}</title>
      <defs>
        <clipPath id="cashier-start-b">
          <path
            d="M1497.45 319.8c-3.12 3.29-5.71 10.94-5.71 10.94s-20.42 6.39-34.52 13.56c-9.17 4.67-19.83 10.77-23.39 16.32-10.37 16.18 22.98 116.03 24.56 144.68 1.58 28.65-2.2 117.04-2.2 117.04s36.76 19.92 77.7 11.3c45.3-9.54 61.82-23.93 77.64-30.38 15.82-6.45 28.76-17.61 28.76-17.61s-39.05-107.75-39.84-137.83c-.79-30.08 13.91-60.14 17.07-72.32 3.16-12.18 1.77-27.43-14.83-36.03-16.61-8.59-42.59-14.17-42.59-14.17s-2.87-6.91-6.12-9.81c-3.25-2.89-53.39 1.01-56.52 4.3Z"
            style={{
              fill: '#e7474c',
            }}
          />
        </clipPath>
        <clipPath id="cashier-start-c">
          <path
            d="m1472.93 403.58 1.52 21.46 47.07-5.24-2.27-20.4c-.63-.06-46.32 4.17-46.32 4.17Z"
            style={{
              fill: '#f1f1f3',
            }}
          />
        </clipPath>
        <style>
          {
            '.d{fill:#0077be}.e{fill:#f1f1f3}.f{fill:#e7474c}.g{fill:#940c3b}.h{fill:#93a090}.i{fill:#9e6c30}.j{fill:#cda67b}.k{fill:#ca332e}.l{fill:#1c3628}.m{fill:#272a3e}.n{fill:#4a9055}.o{clip-path:url(#cashier-start-c)}.p{clip-path:url(#cashier-start-b)}'
          }
        </style>
      </defs>
      <path
        d="M1532.4 206.46s-21.65-13.78-39.76 1.38c-13.9 11.64-1.77 21.26-1.77 21.26s-12.6 5.9-12.6 16.14 1.49 12.51-2.2 15.17c-3.79 2.73-5.69 2.49-5.69 2.49s1.59 8.72 7.69 9.9c6.1 1.18 10.04-.98 10.04-.98s-8.82 20.53-3.11 29.39c5.71 8.86 12.17 9.74 12.17 9.74s-1.13-4.47 3.4-7.62c4.53-3.15 13.33-14.39 24.15-10.05 10.83 4.33 25.45 13.45 31.69 14.37 8.95 1.31 10.69-3.89 10.69-3.89s-5.03-.96-6.35-7.33c-1.11-5.34 2.92-8.83 7.05-11.58 4.13-2.76 6.09-3.76 8.85-10.06 2.76-6.3-.35-11.43-.35-11.43s6.77-1 9.38-6.04c4.6-8.9.59-14.76.59-14.76s-5.7 5.62-11.41.31c-5.71-5.32-4.26-18.48-8-27.54-3.74-9.06-13.57-10.85-20.86-11.22-7.68-.39-13.58 2.36-13.58 2.36Z"
        style={{
          fill: '#93a090',
        }}
      />
      <path
        d="M1595.56 897.93s3.22 28.79 4.18 39.97c.95 11.19.65 29.9.65 29.9l39.57-2.88 3.3-10.67s-9.18-9.63-11.19-24.89 1.34-33.57 1.34-33.57l-37.85 2.14Z"
        style={{
          fill: '#f1f1f3',
        }}
      />
      <path
        d="M1627.4 940.62c-9.74 1.8-11.96 15.25-11.96 15.25s-4.57 2.78-10.66 1.25c-6.1-1.53-5.55-13.64-5.55-13.64l-3.9-.16-6.4 40.42s.58 3.61 16.4 7.13c15.82 3.52 20.39 4.67 25.89 9.93 5.49 5.26 17.03 11.27 28.86 9.65 11.83-1.62 23.3-2.58 23.3-2.58s6.62-16.17-5.08-24.26c-11.69-8.09-13.71-7.12-21.23-15.33-7.52-8.22-9.93-31.31-29.67-27.66Z"
        style={{
          fill: '#272a3e',
        }}
      />
      <path
        d="M1452.7 886.46s-5 41.38-8.77 50.31c-3.77 8.93-6.11 15.3-5.33 15.82s31.91 4.93 31.91 4.93 3.47-20.79 4.77-25.86c1.29-5.06 4.7-33.54 4.7-33.54l-27.27-11.67Z"
        style={{
          fill: '#f1f1f3',
        }}
      />
      <path
        d="M1624.32 559.45s9.83 108.81 9.52 141.99c-.3 33.19-5.62 53.85-4.29 65.94 1.33 12.08 1.71 70.48 2.09 87.33.38 16.85 14.34 88.76 14.34 88.76s-10.6 4.5-26.36 11.51c-11.62 5.17-33.86 0-33.86 0s-16.25-13.49-15.5-26.68c.75-13.18.08-66.68-3.2-86.82-3.14-19.34-4.5-57.3-7.92-70.93-3.53-14.06-8.65-88.58-13.66-107.08-6.47-23.93-18.96-56.51-18.96-56.51l12.03-49.26 85.77 1.75Z"
        style={{
          fill: '#0077be',
        }}
      />
      <path
        d="M1577.57 330.79s34.7 6.9 42.28 20.05c10.14 17.58 39.68 125.75 37.68 145.44-2.01 19.68-16.2 20.66-31.15 14.68-18.53-7.41-30.66-18.98-37.89-41.88-7.23-22.9-6.44-57.15-6.44-57.15l-4.47-81.13Z"
        style={{
          fill: '#e7474c',
        }}
      />
      <path
        d="M1434.37 598.99s9.4 14.28 10.96 18.39c1.56 4.11 2.76 14.15 3.77 18.2 1.02 4.05 2.6 11.7 2.6 11.7s-5.82 1.03-8.2-2.74c-2.38-3.76-4.24-17.04-5.6-16.76-1.36.28 2.62 14.36 4.35 18.43 1.73 4.08 7.09 5.98 9.19 8.38 2.1 2.4 2.49 5.16 2.49 5.16l-13.61 1.94s-10.31-3.54-14.82-4.73c-4.51-1.19-8.03-3.66-10.33-6.2-1.56-1.72-5.46-15.19-5.46-15.19l-2.42-37.68s6.13-.65 12.59-1.99c6.46-1.34 14.48 3.08 14.48 3.08Z"
        style={{
          fill: '#9e6c30',
        }}
      />
      <path
        d="M1434.94 359.5c-14.08 13.35-36.3 112.93-39.91 128.79-1.98 8.7 1.11 35.99 3.27 65.23 2.17 29.23 6.75 57.55 6.75 57.55s11.89.34 20.78-2.48c10.37-3.29 19.67-7.31 19.67-7.31s-2.44-62.63-1.35-82.48c1.08-19.85 22.13-60.81 22.13-60.81l-17.35-93.58-14-4.91ZM1670.46 391.71s-13.68-4.32-25.4-5.96c-17.57-2.45-24.45 3.3-24.45 3.3s-.93 22.98-4.3 37.76c-3.36 14.78-20.71 74.35-20.71 74.35s45.36 24.66 57.22 8.73c8.77-11.78 14.5-49.97 15.32-79.3.78-28.05 2.33-38.89 2.33-38.89Z"
        style={{
          fill: '#e7474c',
        }}
      />
      <path
        d="M1450.15 938.17c-9.47 1.06-16.45 11.07-15.39 18.61 1.07 7.54-3.37 22.52-6.5 29.11s1.71 22.92 1.71 22.92 13.27 6.74 27.26 5.12c13.98-1.62 25.29-2.66 26.02-9.98.73-7.32-9.03-17.02-8.64-25.9.4-8.88 4.81-11.33 1.66-19.08-3.16-7.76-8.31-11.29-8.31-11.29s-3.23-11.15-17.81-9.51Z"
        style={{
          fill: '#272a3e',
        }}
      />
      <path
        d="M1555.15 556.71c.25-.9-11.48 117.42-20.46 168.89-7.62 43.68-19.38 52.96-21.13 61.26-1.75 8.31-.61 108.67-5.91 127.78-5.29 19.11-17.07 43.26-17.07 43.26s-27.4 2.77-39.01 2.85c-11.62.09-22.75-5.6-22.75-5.6s1.63-55.69 8.94-92.59c7.31-36.91 11.06-77.53 12.6-89.56 1.53-12.03 3.67-12.37 3.55-29.82-.12-17.45-1.34-82.24 2.12-111.01 3.46-28.77 18.01-85.46 18.01-85.46l81.12 10.01Z"
        style={{
          fill: '#0077be',
        }}
      />
      <path
        d="M1497.45 319.8c-3.12 3.29-5.71 10.94-5.71 10.94s-20.42 6.39-34.52 13.56c-9.17 4.67-19.83 10.77-23.39 16.32-10.37 16.18 22.98 116.03 24.56 144.68 1.58 28.65-2.2 117.04-2.2 117.04s36.76 19.92 77.7 11.3c45.3-9.54 61.82-23.93 77.64-30.38 15.82-6.45 28.76-17.61 28.76-17.61s-39.05-107.75-39.84-137.83c-.79-30.08 13.91-60.14 17.07-72.32 3.16-12.18 1.77-27.43-14.83-36.03-16.61-8.59-42.59-14.17-42.59-14.17s-2.87-6.91-6.12-9.81c-3.25-2.89-53.39 1.01-56.52 4.3Z"
        style={{
          fill: '#e7474c',
        }}
      />
      <g
        style={{
          clipPath: 'url(#cashier-start-b)',
        }}
      >
        <path
          d="M1491.1 316.37s-1.43 19.24 5.75 26.83 24.91 23.64 24.91 23.64l15.65-15.33 12.66 9.1s6.79-7.51 9.32-19.44c1.79-8.43-.9-24.8-.9-24.8s1.15-22.41.4-22.64c-.76-.23-69.54.92-69.54.92l1.75 21.73Z"
          style={{
            fill: '#ca332e',
          }}
        />
      </g>
      <path
        d="M1550.22 466.06c1.33.09 2.22 1.06 2.08 2.38.04-.44.54 1.81-2.22 1.81-1.42 0-2.17-.92-2.17-2.3 0-.97.93-1.98 2.3-1.89ZM1543.67 413.59c1.33.09 2.22 1.06 2.08 2.38.04-.44.54 1.81-2.22 1.81-1.42 0-2.17-.92-2.17-2.3 0-.97.93-1.98 2.3-1.89ZM1537.85 366.46c1.33.09 2.22 1.06 2.08 2.38.04-.44.54 1.81-2.22 1.81-1.42 0-2.17-.92-2.17-2.3 0-.97.93-1.98 2.3-1.89ZM1553.96 504.56c1.33.09 2.22 1.06 2.08 2.38.04-.44.54 1.81-2.22 1.81-1.42 0-2.17-.92-2.17-2.3 0-.97.93-1.98 2.3-1.89ZM1556.91 548.87c1.33.09 2.22 1.06 2.08 2.38.04-.44.54 1.81-2.22 1.81-1.42 0-2.17-.92-2.17-2.3 0-.97.93-1.98 2.3-1.89Z"
        style={{
          fill: '#940c3b',
        }}
      />
      <path
        d="M1498.69 275.9s4.24 17.56 3.9 29.27c-.34 11.72-3.44 15.61-2.13 19.99 3.25 10.82 35.68 24.42 35.68 24.42-.13.04 18.78-10.59 19.2-21.03.09-2.25-7.81-8.66-7.1-17.88.74-9.65.26-22.54.26-22.54l-49.82-12.24Z"
        style={{
          fill: '#9e6c30',
        }}
      />
      <path
        d="M1526.61 227.16c-8.27-.48-16.07-3.4-20.79 4.27-4.72 7.68.91 19.15-.86 23.48-1.77 4.33-8.07 3.94-8.07 3.94s-3.54 4.53-1.97 11.02c1.57 6.5.74 26.94 4.48 32.26 3.74 5.31 12.92 12.68 18.43 17.01 5.51 4.33 20.01 2.9 24.73-1.23 4.72-4.13 13.9-15.38 15.67-19.32s2.44-23.59 3.03-29.89c.59-6.3-.59-14.76-.59-14.76s-7.09-2.36-7.87-11.22c-.47-5.3-1.25-14.3-6.65-17.85-12.48-8.21-13.79 2.63-19.53 2.3Z"
        style={{
          fill: '#9e6c30',
        }}
      />
      <path
        d="M1539.14 259.03s14.3-3.42 15.75-2.69c1.45.73 3.39 3.88 3.39 3.88l-1.58 1.82s-1.89-2.66-4.3-2.37c-3.37.41-12.3 3.97-12.3 3.97l-.97-4.6ZM1524.11 259.7l-.12 4.6s-12.72-3.61-15.62-2.52c-2.91 1.09-4.85 2.06-4.85 2.06l-.97-1.82s3.15-3.76 5.94-4.48c2.79-.73 15.62 2.15 15.62 2.15Z"
        style={{
          fill: '#93a090',
        }}
      />
      <path
        d="M1519 302.71c.34 1.82 6.62 2.94 13.31 2.84 6.49-.1 10.5-3.4 10.86-4.77.36-1.37.6-4.44-1.83-5.47-2.42-1.03-4.98-1.24-6.8-.55-1.82.69-1.55 1.49-2.76 1.83-1.21.34-3.06-1.49-5.96-.97-2.91.51-4.35.82-5.77 2.02-1.01.85-1.53 2.51-1.05 5.08Z"
        style={{
          fill: '#cda67b',
        }}
      />
      <path
        d="M1515.3 265.77c-1.9-.53-3.6.38-4.05 2.26-.45 1.88.55 2.98 2.22 3.57 1.98.69 3.47-.21 4.13-2.1.47-1.33-.35-3.18-2.3-3.73Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        style={{
          fill: '#1c3628',
        }}
        d="m1508.53 265.27 11.41 2.79 1.19-3.63-13.43-3 .83 3.84zM1547.5 264.55c1.96-.21 3.49.96 3.62 2.89.13 1.93-1.03 2.85-2.78 3.15-2.06.36-3.39-.77-3.73-2.74-.24-1.39.86-3.08 2.88-3.3Z"
      />
      <path
        style={{
          fill: '#1c3628',
        }}
        d="m1553.81 263.35-10.6 4.39-1.24-3.31 11.54-4.75.3 3.67z"
      />
      <path
        d="M1495.57 267.48s-7.02-1.98-6.19 3.82c.83 5.8 3.77 17.13 6.91 16.19 3.14-.94 5.01-4.31 5.01-4.31l-5.73-15.69ZM1557.8 284.68s3.02 2.81 4.75-1.51 4.75-16.83 2.59-17.7c-2.16-.86-6.04 1.51-6.04 1.51l-1.29 17.7ZM1660.07 390.8c2.67-2.78 25.36-37.83 26.41-39.62 1.05-1.79 8.15-28.12 8.15-28.12s-3.55-1.6-5.47-.28-4.46 6.64-4.46 6.64l.97-8.99s-4.38-1.01-6.17 2.78-3.27 15.45-3.98 16.84c-.71 1.39-1.14 2.04-1.14 2.04l-.91-20.2s-5.05.76-5.75 3.13c-.7 2.37-.64 16.82-.82 17.92-.55 3.26-3.73 5.13-4.39 5.32-.66.19 1.12-2.84 1.23-6.12.11-3.28-.44-13.07-.44-13.07s-4.22-.9-5.81 2.69c-.95 2.16-.31 9.59-.63 11.2-.32 1.61-5.2 13.27-6.54 15.23s-12.11 11.78-14.32 21.86c-.88 4.03-3.21 13.81-2.01 13.86 7.4.34 17.16 6.18 26.08-3.1Z"
        style={{
          fill: '#9e6c30',
        }}
      />
      <path
        style={{
          fill: '#0077be',
        }}
        d="m1544.21 642.94 13.91-58.9 24.89 55.2-38.8 3.7z"
      />
      <path
        d="m1472.93 403.58 1.52 21.46 47.07-5.24-2.27-20.4c-.63-.06-46.32 4.17-46.32 4.17Z"
        style={{
          fill: '#f1f1f3',
        }}
      />
      <g
        style={{
          clipPath: 'url(#cashier-start-c)',
        }}
      >
        <path
          style={{
            fill: '#4a9055',
          }}
          d="m1463.83 409.54 60.28-5.02-2.38-15.6-56.05 6.61-1.85 14.01z"
        />
      </g>
      <path
        d="M1560.72 250.21s-3.25 41.74-6.63 44.14c-5.72 4.06-7.89-3.35-13.53-3.98-5.85-.65-7.43 1.69-8.94 1.75-1.51.06-6.17-1.86-10.44-.53-3.03.95-8.25 7.28-13.4 6.93-6.48-.45-6.31-11.06-6.96-13.17-3.68-11.92-4.27-29.71-4.27-29.71l-2.98 1.4s2.14 36.68 4.67 42.81c2.54 6.13 5.92 12.76 10.78 16.35s7.9 7.89 11.54 8.48c5.26.86 18.38.57 22.61-2.39s13.8-17.44 15.28-20.4c1.48-2.96 2.01-24.74 2.47-27.65 1.33-8.54 1.91-21.77 1.91-21.77l-2.1-2.28Zm-25.15 61.39c-5.71 1.06-11.61 1.16-15.2-.53-1.27-.6-5.79-2.34-6.48-5.29-.69-2.96 5-11.07 9.71-11.7 4.26-.56 5.5.71 7.56.71s4.29-2.97 8.53-1.79c3.59 1 9.48 6.6 8.9 9.17-.89 3.91-9.45 8.77-13 9.43Z"
        style={{
          fill: '#93a090',
        }}
      />
    </svg>
  )
}

export default CashierStart
